<template>
  <toast></toast>

  <router-view @need-login="showLoginDialog" @to-app="showVipDialogClick"></router-view>

  <login v-show="showLogin" @close-login="closeLoginDialog" transition="fade" transition-mode="out-in"></login>
  <dialog :show.sync="showVipDialog" :title="dialogTitle" :title2="content" :right="button" :left="'取消'" @right-btn-click="goApp"
          transition="fade" transition-mode="out-in"></dialog>

  <template v-if="isMain">

    <div class="ui-page-holder"></div>
    <div class="ui-cart" @click="clickCart">
      <div v-if="cartCount>0" class="ui-cart-num">{{cartCount}}</div>
    </div>
    <div class="ui-account" @click="clickMine">
    </div>

  </template>

  <loading :show.sync="load"></loading>
  <first-red-packet-modal></first-red-packet-modal>
</template>
<script>
  import toast from './components/toast.vue'
  import FirstRedPacketModal from './components/FirstRedPacketModal.vue'
  import {registerRoot} from './libs/utils'
  import http from './libs/http'
  import loading from './components/loading.vue'
  import {autoLogin} from './stores/actions'
  import store from './stores'
  import dialog from './components/dialog.vue'
  import {toNative} from './libs/other';

  export default {
    store,
    vuex: {
      actions: {
        autoLogin
      },
      getters: {
        isLogin: (state) => state.user.isLogined,
        cartCount: (state) => state.cart.count,

        user: (state) => state.user.user,
        membership: (state) => state.user.user.membership,
      }
    },

    components: {
      login(resolve) {
        require.ensure(['./components/login.vue'], function (require) {
          const component = require('./components/login.vue');
          resolve(component);
        }, 'login')
      },
      toast,
      loading,
      dialog,
      FirstRedPacketModal,
    },

    computed: {
      isMain() {
        return this.tab[this.$route.name] != null;
      },
      title() {
        return this.$route.title || document.title;
      }
    },

    watch: {
      title(val) {
        document.title = val;
      }
    },

    async created() {
      http.setLoadingDelegate(this);
      document.title = this.title;
      await this.autoLogin()

      if (this.membership == 1) {
        this.dialogTitle = '您已开通普通会员'
        this.content = '请登录纹身大咖APP查看会员权益或升级到超级会员'
      }else if (this.membership == 2)  {
        this.dialogTitle = '您已开通超级会员'
        this.content = '请登录纹身大咖APP查看会员权益'
      }
    },

    data() {
      return {
        background_color: '#f0f0f0',
        tab: {},

        showLogin: false,
        showVipDialog: false,
        topNav: window.isWsdk,
        isAndroid: bridge.isAndroid,
        load: false,
        dialogTitle: '开通会员需要',
        content: '下载纹身大咖官方APP',
        button: '前往下载',
      }
    },

    ready() {

      if (window.isWsdk) {
        this.tab = {
          home: {
            title: '首页'
          },
          cate: {
            title: '分类'
          },
          mine: {
            title: '账户'
          }
        };
      } else
        this.tab = {
          home: {
            title: '首页'
          },
          cate: {
            title: '分类'
          },
          mine: {
            title: '我的',
            img: 'me'
          }
        };

      registerRoot(this);
      this.$on('toast', (content) => {
        this.$broadcast('toast', content);
      });


    },

    methods: {
      closeLoginDialog() {
        this.showLogin = false;
      },
      showLoginDialog() {
        this.showLogin = true;
      },
      closeVipDialogClick() {
        this.showVipDialog = false;
      },
      showVipDialogClick() {
        this.showVipDialog = true;
      },
      close() {
        wsdk.close();
      },
      test() {
        console.log(this.$route);
      }, loading() {
        this.load = true;
      }, loaded() {
        this.load = false;
      }, toast(msg) {
        console.log(msg);
        this.$emit('toast', msg);
      },

      clickCart() {
        if (this.isLogin)
          wsdk.go({url: 'cart', type: pageType.H5});
        else
          this.showLoginDialog();
      },

      clickMine() {
        if (this.isLogin)
          wsdk.go({url: 'mine', type: pageType.H5});
        else
          this.showLoginDialog();
      },

      goApp() {
        toNative(navigator.userAgent)
      }
    }
  }
</script>

<style lang="less">
  @import '../static/less/index.less';

  /* 必需 */
  .expand-transition {
    transition: all .3s ease;
    height: 100%;
    overflow: hidden;
  }

  .iosStatusBar {
    background: #fff;
  }

  /* .expand-enter 定义进入的开始状态 */
  /* .expand-leave 定义离开的结束状态 */
  .expand-enter {

  }
</style>



// WEBPACK FOOTER //
// App.vue?7f61700b